/**
 * GridLayout的方法
 * add by liyaoh: 2021-03-30
 */
import { APP_DEFAULT_SIZE } from "../utilService";
/**
 * 生成layout数据
 *
 * @param {*} items
 * @param {*} col: 栅格列数
 * @return {*} { lg: layouts }
 */
export function generateLayout(items, col) {
    const layouts = items.map((item, index) => {
        const { x, y } = calcGridItemPos(col, index);
        return {
            x: item.gridx !== undefined ? +item.gridx : x,
            y: item.gridy !== undefined ? +item.gridy : y,
            w: +item.width,
            h: +item.height,
            i: item.cardid,
        };
    });
    return { lg: layouts };
}

/**
 * 计算GridItem的位置
 *
 * @param {*} col 栅格列数
 * @param {*} index 元素的index
 * @return {*} 元素坐标 { x, y }
 */
function calcGridItemPos(col, index) {
    const size = APP_DEFAULT_SIZE.width; //应用默认大小，占几列栅格
    const x = (index * size) % col;
    const y = Math.floor(index / (col / size)) * size;
    return { x, y };
}

//dom碰撞检测
export function collidesDom(domA, domB) {
    const threshold = 1; //碰撞阈值
    const a = getScaleRect(domA, threshold);
    const b = getScaleRect(domB, threshold);
    if (
        a.left > b.right ||
        a.top > b.bottom ||
        a.right < b.left ||
        a.bottom < b.top
    ) {
        return false; // 未碰撞
    } else {
        return true; // 碰撞
    }
}

//获取缩放后的domRect scale：缩放比例0-1之间
export function getScaleRect(dom, scale) {
    const rect = dom.getBoundingClientRect();
    const offsetX = (rect.width * (1 - scale)) / 2;
    const offsetY = (rect.height * (1 - scale)) / 2;
    const newX = rect.x + offsetX;
    const newY = rect.y + offsetY;
    const newWidth = rect.width * scale;
    const newHeight = rect.height * scale;

    return {
        x: newX,
        y: newY,
        width: newWidth,
        height: newHeight,
        top: newY,
        left: newX,
        right: newX + newWidth,
        bottom: newY + newHeight,
    };
}

export function getAllCollisions(domList, dom) {
    return domList.filter(l => dom.id !== l.id && collidesDom(l, dom));
}

